// muiLogoHutRewardsStyles.tsx
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { ImageUrls } from '../../../utils/imageUtils';
import type { LogoHutRewardsImageProps as _LogoHutRewardsImageProps } from '../../../types/interfaces/LogoHutRewardInterface';


// Container
export const LogoHutRewardsContainer = styled(Box)({
  padding: '10px 0 20px 0',
});

// Props (ensure optionality + literals)
export interface LogoHutRewardsImageProps
  extends Omit<_LogoHutRewardsImageProps, never> {
  size?: 'medium' | 'large' | 'x-large';
  showBgImage?: boolean;
}

// Image as background on an h1 (keeps accessible text, visually hidden)
export const LogoHutRewardsImage = styled('h1', {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'showBgImage',
})<LogoHutRewardsImageProps>(({ size = 'medium', showBgImage }) => {
  const base = {
    textIndent: '-9999px',
    textTransform: 'uppercase' as const,
    margin: 0,
  };

  if (!showBgImage) return base;

  switch (size) {
    case 'medium':
      return {
        ...base,
        background: `url("${ImageUrls.hrLogo}") no-repeat`,
        backgroundSize: 'contain',
        width: 275,
        height: 49,
        marginLeft: -10,
        '@media (max-width: 767.98px)': {
          background: `url("${ImageUrls.hrLogo}") no-repeat`, // same as original
        },
      };

    case 'large':
      return {
        ...base,
        background: `url("${ImageUrls.hrLogo}") no-repeat`,
        backgroundSize: 'contain',
        width: 426,
        height: 78,
        marginLeft: -13,
        '@media (max-width: 767.98px)': {
          background: `url("${ImageUrls.hrLogo}") no-repeat`,
          width: 360,
          height: 70,
          backgroundSize: 'contain',
        },
      };

    case 'x-large':
      return {
        ...base,
        margin: '0 auto',
        background: `url("${ImageUrls.hrLogo}") no-repeat`,
        backgroundSize: 'contain',
        width: 275,
        height: 49,
        '@media (max-width: 767.98px)': {
          background: `url("${ImageUrls.hrLogo}") no-repeat`, // keep original behavior; swap to MOBILE if desired
          width: 500,
          height: 120,
        },
        '@media (min-width: 992px)': {
          width: 540,
          height: 147,
        },
      };

    default:
      return base;
  }
});
